<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Facility
    </button>

    <a-modal v-model="visible" title="Add new facility">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-12">
            <a-form-item label="Facility Name">
              <a-input
                placeholder="Facility Name"
                v-decorator="['name', {rules: [{ required: true, message: 'Please input a facility name!' }]}]"
              />
            </a-form-item>
          </div>

<!--          <div class="col-12 col-md-6">-->
<!--            <a-form-item label="Status">-->
<!--              <a-select v-decorator="['status', { rules: [{ required: false, message: 'Facility status is required!!' }] } ]" placeholder="Facility Status">-->
<!--                <a-select-option v-for="facilityStatus in facilitiesStatus" :value="facilityStatus.value" :key="facilityStatus.value">-->
<!--                  {{ facilityStatus.name }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </div>-->
        </div>

<!--        <div class="row">-->
<!--          <div class="col-12">-->
<!--            <a-form-item label="Quantity">-->
<!--              <a-input-number-->
<!--                :min="1"-->
<!--                v-decorator="['quantity',{initialValue: '1'}, {rules: [{ required: true, message: 'Please input quantity!'}]}]"-->
<!--                style="width: 100%"-->
<!--              />-->
<!--            </a-form-item>-->
<!--          </div>-->
<!--        </div>-->

        <div class="mb-2">
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
        </div>

        <div class="mb-2">
          <a-form-item label="Usage Restrictions">
            <a-textarea placeholder="Usage Restrictions" :autosize="{minRows: 2}" v-decorator="['usage_restrictions']" />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { facilitiesStatus } from '@/services/globaldata'
export default {
  name: 'facilityAddModal',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      facilitiesStatus,
    }
  },
  watch: {
    formVisible: function(n, o) {
      this.visible = n
    },
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleCancel(e) {
      this.visible = false
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the facility!`,
            onOk: () => {
              this.$nprogress.start()
              this.$http
                .post('/api/hostel/facility/add', {
                  name: values.name,
                  // quantity: values.quantity,
                  description: values.description,
                  // status: values.status,
                  usage_restrictions: values.usage_restrictions,
                })
                .then((data) => {
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification['success']({
                    message: 'Facility successfully added!',
                    description: `Facility ${values.name} added successfully!`,
                  })
                })
                .catch(error => {
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              console.log('Cancel')
            },
          })
        }
      })
    },
  },
}
</script>
